<template>
  <div>
    <b-col md="12">
      <b-overlay
        :show="loader"
        rounded="lg"
        opacity="0.6"
      >
        <b-form-group
          label="Select The Condition"
          :label-for="`condition-${data}`"
        >
          <vSelect
            v-model="componentObject.condition_id"
            :disabled="busy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="conditions"
            :class="`form-group-${data}`"
            :reduce="val => val.value"
            :clearable="false"
            data-id="condition_id"
            data-fieldtype="select"
            :input-id="`condition_id-${data}`"
            @input="changeVariable($event, data)"
          />
        </b-form-group>
        <!-- Statements -->
        <b-form-group
          v-if="componentObject.condition_id === statementConditionID"
          :label="SubStatementLabel"
          label-for="sub-statement-option"
        >
          <v-select
            v-model="sub_statements"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="SubStatementOptions"
            :class="`form-group-${data}`"
            :reduce="val => val.value"
            :clearable="false"
            data-id="sub_statements"
            data-fieldtype="select"
            :input-id="`sub_statements-${data}`"
            multiple
            @input="vSelectChanged(sub_statements, `sub_statements-${data}`)"
          />
        </b-form-group>
        <!-- Statements End -->
        <b-form-group
          v-if="componentObject.condition_id === statementConditionID"
          label="Value"
          label-for="statement-value"
        >
          <b-form-input
            :id="`subStatementValue-${data}`"
            v-model="componentObject.subStatementValue"
            :class="`form-group-${data}`"
            data-id="subStatementValue"
            data-fieldtype="input"
            placeholder="Value"
            @change="valuechanged($event, `subStatementValue-${data}`)"
          />
        </b-form-group>

        <!-- Custom Vars -->
        <b-form-group
          v-if="CustomVariableOptions.length > 0"
          :label="$t('DEBTIA_OPTIONS')"
          label-for="custom-var-options"
        >
          <v-select
            v-model="componentObject.custom_option_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="CustomVariableOptions"
            :class="`form-group-${data}`"
            :reduce="val => val.value"
            :clearable="false"
            data-id="custom_option_id"
            data-fieldtype="select"
            :input-id="`custom_option_id-${data}`"
            @input="vSelectChanged(componentObject.custom_option_id, `custom_option_id-${data}`)"
          />
        </b-form-group>

        <b-form-group
          v-if="varType !== false && varType !== 'select'"
          :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          label-for="custom-variable-value"
        >
          <vue-timepicker
            v-if="varType === 'time'"
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            input-width="100%"
            :input-class="`form-control form-group-${data}`"
            data-id="custom_variable_value"
            data-fieldtype="input"
            manual-input
            hide-clear-button
            @change="valuechanged(componentObject.custom_variable_value, `custom_variable_value-${data}`)"
          />
          <v-select
            v-else-if="varType === 'date'"
            v-model="dateOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="dateOptions"
            :class="`form-group-${data}`"
            :reduce="val => val.value"
            :clearable="false"
            data-id="dateOption"
            data-fieldtype="select"
            :input-id="`dateOption-${data}`"
            @input="vSelectChanged(dateOption, `dateOption-${data}`)"
          />
          <b-form-textarea
            v-else-if="varType === 'multiline string'"
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
            data-id="custom_variable_value"
            data-fieldtype="textarea"
            :class="`form-group-${data}`"
            rows="3"
            @change="valuechanged(componentObject.custom_variable_value, `custom_variable_value-${data}`)"
          />
          <b-form-radio-group
            v-else-if="varType === 'boolean'"
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            :options="radioOptions"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            data-id="custom_variable_value"
            data-fieldtype="radio"
            :class="`demo-inline-spacing form-group-${data}`"
            @change="radiochange(data)"
          />
          <b-form-input
            v-else-if="varType === 'number'"
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            type="number"
            :class="`form-group-${data}`"
            data-id="custom_variable_value"
            data-fieldtype="input"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
            @change="valuechanged(componentObject.custom_variable_value, `custom_variable_value-${data}`)"
          />
          <b-form-input
            v-else
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            :class="`form-group-${data}`"
            data-id="custom_variable_value"
            data-fieldtype="input"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
            @change="valuechanged(componentObject.custom_variable_value, `custom_variable_value-${data}`)"
          />
        </b-form-group>
        <label
          :id="`radioerror-${data}`"
          class="boolean-error"
        >Please choose one option.</label>
        <b-form-group
          v-if="varType !== false && varType === 'date'"
          :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          label-for="custom-variable-value"
        >
          <b-input-group
            v-if="dateOption === 1"
          >
            <cleave
              :id="`custom_variable_value-${data}`"
              v-model="componentObject.dacustom_variable_value"
              class="form-control"
              :class="`daform-group-${data}`"
              :raw="false"
              :options="options.date"
              placeholder="DD-MM-YYYY"
              data-id="datepicker"
              data-fieldtype="input"
              @input="validateDate(0, componentObject.dacustom_variable_value)"
            />
            <b-input-group-append
              :id="`custom_variable_value-${data}`"
            >
              <b-form-datepicker
                v-model="componentObject.custom_variable_value"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                :class="`form-group-${data}`"
                trim
                button-only
                right
                size="sm"
                data-id="datepicker"
                data-fieldtype="input"
                @input="validateDate(1, componentObject.custom_variable_value)"
              />
            </b-input-group-append>
          </b-input-group>
          <b-form-input
            v-if="dateOption !== 1"
            :id="`custom_variable_value-${data}`"
            v-model="componentObject.custom_variable_value"
            :class="`form-group-${data}`"
            data-id="custom_variable_value"
            type="number"
            data-fieldtype="input"
            placeholder="Dato Felt"
            @change="valuechanged(componentObject.custom_variable_value, `custom_variable_value-${data}`)"
          />
        </b-form-group>
        <!-- Custom Vars End -->

        <!-- Client Type -->
        <b-form-group
          v-if="componentObject.condition_id === clientTypeConditionID"
          :label="$t('DEBTIA_CLIENT_TYPE')"
          label-for="client type"
        >
          <v-select
            v-model="componentObject.client_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="clientTypeOptions"
            :class="`form-group-${data}`"
            :clearable="false"
            data-id="client_type"
            data-fieldtype="select"
            :input-id="`client_type-${data}`"
            :reduce="val => val.value"
            @input="vSelectChanged(componentObject.client_type, `client_type-${data}`)"
          />
        </b-form-group>

        <!-- File Categories -->
        <b-form-group
          v-if="componentObject.condition_id === 5"
          :label="$t('DEBTIA_FILE_CATEGORIES')"
          label-for="file-category"
        >
          <v-select
            v-model="componentObject.file_category_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="fileCategories"
            :reduce="val => val.value"
            :class="`form-group-${data}`"
            :clearable="false"
            data-id="file_category_id"
            data-fieldtype="select"
            :input-id="`file_category_id-${data}`"
            @input="vSelectChanged(componentObject.file_category_id, `file_category_id-${data}`)"
          />
        </b-form-group>
        <!-- File Categories Ends -->

        <!-- Case Groups -->
        <b-form-group
          v-if="componentObject.condition_id === 6"
          :label="$t('DEBTIA_CASE_GROUPS')"
          label-for="case-group"
        >
          <v-select
            v-model="componentObject.debt_case_group_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="CaseGroups"
            :reduce="val => val.value"
            :clearable="false"
            :class="`form-group-${data}`"
            data-id="debt_case_group_id"
            data-fieldtype="select"
            :input-id="`debt_case_group_id-${data}`"
            @input="vSelectChanged(componentObject.debt_case_group_id, `debt_case_group_id-${data}`)"
          />
        </b-form-group>
        <!-- Case Groups Ends -->

        <!-- Is the field filled -->
        <b-form-group
          v-if="componentObject.condition_id === 10"
          :label="$t('DEBTIA_TYPE')"
          label-for="custom-var-for"
        >
          <v-select
            v-model="componentObject.custom_variable_value"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVarsForArgs"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`custom_variable_value-${data}`"
            data-id="custom_variable_value"
            data-fieldtype="select"
            :class="`form-group-${data}`"
            @input="getVarsFor(), vSelectChanged(customVarsFor, `custom_variable_value-${data}`)"
          />
        </b-form-group>

        <b-form-group
          v-if="componentObject.condition_id === 10"
          :label="$t('DEBTIA_CUSTOM_VARIABLES')"
          label-for="custom-var"
        >
          <v-select
            v-model="componentObject.custom_variable_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVars"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`custom_variable_id-${data}`"
            data-id="custom_variable_id"
            data-fieldtype="select"
            :class="`form-group-${data}`"
            :value="''"
            @input="vSelectChanged(componentObject.custom_variable_id, `custom_variable_id-${data}`)"
          >
            <template
              #selected-option-container="{ option }"
            >
              <div class="vs__selected">
                {{ $t(option.label) }}</div>
            </template>
            <template
              slot="option"
              slot-scope="option"
            >
              {{ $t(option.label) }}
            </template>
          </v-select>
        </b-form-group>
        <!-- Is the field filled, ends -->

        <b-form-group
          v-if="componentObject.condition_id === interestTypeConditionID"
          label="Type"
          label-for="sub-statement-option"
        >
          <v-select
            v-model="componentObject.interest_type_condition"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="interestConditionOptions"
            :reduce="val => val.value"
            :clearable="false"
            :class="`form-group-${data}`"
            data-id="interest_type_condition"
            data-fieldtype="select"
            :input-id="`interest_type_condition-${data}`"
            @input="vSelectChanged(componentObject.interest_type_condition, `interest_type_condition-${data}`)"
          />
        </b-form-group>

        <!-- DEB-790 Collection client type condition -->
        <b-form-group
          v-if="componentObject.condition_id === clientCollectionTypeID"
          label="Type"
          :label-for="`client_collection_type-${data}`"
        >
          <v-select
            v-model="componentObject.client_collection_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="clientCollectionTypeOptions"
            :class="`form-group-${data}`"
            :reduce="val => val.value"
            :clearable="false"
            data-id="client_collection_type"
            data-fieldtype="select"
            :input-id="`client_collection_type-${data}`"
            @input="vSelectChanged(componentObject.client_collection_type, `client_collection_type-${data}`)"
          />
        </b-form-group>

        <b-form-group
          label="Select The Operator"
          :label-for="`condition-operator-${data}`"
        >
          <v-select
            v-if="componentObject.condition_id === statementConditionID"
            v-model="componentObject.condition_operator_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statementOperatorOptions"
            :reduce="val => val.value"
            :clearable="false"
            :class="`form-group-${data}`"
            data-id="condition_operator_id"
            data-fieldtype="select"
            :input-id="`condition_operator_id-${data}`"
            @input="vSelectChanged(componentObject.condition_operator_id, `condition_operator_id-${data}`)"
          />
          <v-select
            v-else
            v-model="componentObject.condition_operator_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="getOptions(componentObject)"
            :reduce="val => val.value"
            :clearable="false"
            :class="`form-group-${data}`"
            data-id="condition_operator_id"
            data-fieldtype="select"
            :input-id="`condition_operator_id-${data}`"
            @input="vSelectChanged(componentObject.condition_operator_id, `condition_operator_id-${data}`)"
          />
        </b-form-group>
        <b-form-group
          label="If Condition is true"
          :label-for="`true-condition-${data}`"
        >
          <v-select
            v-model="componentObject.true_value.variable"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="templateVariableOptions"
            :reduce="val => val.value"
            :clearable="false"
            class="mb-1"
            @input="yesnoValueChanged($event, 1)"
          >
            <template
              slot="option"
              slot-scope="option"
            >
              <div :class="assignClass(option.value) ? 'autofik' : ''">
                {{ option.label }}
              </div>
            </template>
          </v-select>
          <extra-fields
            :activated-field="componentObject.true_value.variable ? componentObject.true_value.variable : ''"
            :convert-currencies-options="convertCurrenciesOptions"
            :prev-module-options="prevModuleOptions"
            :statements-options="statementsOptions"
            :field-object="componentObject.true_value"
            :data="data"
            type="true_value"
            :letter-templates="letterTemplates"
            :statements="statements"
          />
        </b-form-group>
        <b-form-group
          label="If Condition is false"
          :label-for="`false-condition-${data}`"
        >
          <v-select
            v-model="componentObject.false_value.variable"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="templateVariableOptions"
            :reduce="val => val.value"
            :clearable="false"
            class="mb-1"
            @input="yesnoValueChanged($event, 0)"
          >
            <template
              slot="option"
              slot-scope="option"
            >
              <div :class="assignClass(option.value) ? 'autofik' : ''">
                {{ option.label }}
              </div>
            </template>
          </v-select>
          <extra-fields
            :activated-field="componentObject.false_value.variable ? componentObject.false_value.variable : ''"
            :convert-currencies-options="convertCurrenciesOptions"
            :prev-module-options="prevModuleOptions"
            :statements-options="statementsOptions"
            :field-object="componentObject.false_value"
            :data="data"
            type="false_value"
            :letter-templates="letterTemplates"
            :statements="statements"
          />
        </b-form-group>
      </b-overlay>
    </b-col>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
  BCol,
  BFormInput,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
// import { ValidationProvider/* , ValidationObserver */ } from 'vee-validate'
import VueTimepicker from 'vue2-timepicker'
import Cleave from 'vue-cleave-component'
import 'vue2-timepicker/dist/VueTimepicker.css'
import ExtraFields from './ExtraFields.vue'

export default {
  components: {
    vSelect,
    BFormGroup,
    BCol,
    BFormInput,
    // ValidationProvider,
    // ValidationObserver,
    BFormRadioGroup,
    BFormDatepicker,
    VueTimepicker,
    BFormTextarea,
    BOverlay,
    ExtraFields,
    Cleave,
    BInputGroupAppend,
    BInputGroup,
  },
  props: {
    moduleType: {
      type: String,
      required: false, // Not required
      default: '', // Optional default value
    },
    removeErrorMsg: {
      type: Function,
      required: true,
    },
    componentObject: {
      type: Object,
      required: true,
    },
    conditions: {
      type: Array,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    busy: {
      type: Boolean,
      required: true,
    },
    statementConditionID: {
      type: Number,
      required: false,
      default: 0,
    },
    clientTypeConditionID: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    interestTypeConditionID: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    airportsData: {
      type: Array,
      required: true,
    },
    emailVar: {
      type: Object,
      required: true,
    },
    templateVariableOptions: {
      type: Array,
      required: true,
    },
    assignClass: {
      type: Function,
      required: true,
    },
    convertCurrenciesOptions: {
      type: Array,
      required: true,
    },
    prevModuleOptions: {
      type: Array,
      required: true,
    },
    statementsOptions: {
      type: Array,
      required: true,
    },
    mappableId: {
      type: String,
      required: true,
    },
    letterTemplates: {
      type: Array,
      required: true,
    },
    statements: {
      type: Array,
      required: true,
    },
    emailTemplateId: {
      type: [Number, String],
      required: false, // Not required
      default: '', // Optional default value
    },
    clientCollectionTypeID: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loader: false,
      operatorOptions: [
        { label: 'True', value: 1 },
        { label: 'False', value: 2 },
      ],
      statementOperatorOptions: [
        { label: 'Greater Than (>)', value: 7 },
        { label: 'Greater Than, Equal to (>=)', value: 9 },
        { label: 'Less Than (<)', value: 8 },
        { label: 'Less Than, Equal to (<=)', value: 10 },
        { label: 'Equal to (=)', value: 3 },
      ],
      interestConditionOptions: [
        { label: 'First', value: 'first' },
        { label: 'Last', value: 'last' },
        { label: 'Any', value: 'any' },
      ],
      clientTypeOptions: [
        { label: 'Person', value: 'person' },
        { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
        { label: 'Capital Company', value: 'capital-company' },
      ],
      currentcondition: '',
      operator: '',
      SubStatementLabel: '',
      sub_statements: [],
      SubStatementOptions: [],
      SubStatementValue: '',
      customVarsArgs: [],
      customVars: [],
      CustomVariableOptions: [],
      varType: false,
      CustomVarOption: '',
      CustomVariableValue: '',
      CustomVarID: 0,
      dateOptions: [
        { label: 'Custom Date', value: 1 },
        { label: 'Dato Felt', value: 2 },
      ],
      dateOption: 1,
      fileCategory: '',
      fileCategories: [],
      CaseGroup: '',
      CaseGroups: [],
      customVarsFor: 'debtor',
      customVarsForArgs: [
        {
          label: 'Debtor',
          value: 'debtor',
        },
        {
          label: 'Case',
          value: 'case',
        },
      ],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      mappable_validation_fields: {},
      fieldObject: {},
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      clientCollectionTypeOptions: [
        { label: 'Own', value: 'own' },
        { label: 'Foreign', value: 'foreign' },
      ],
    }
  },
  watch: {
    'componentObject.condition_operator_id': {
      handler() {
        const conditionValue = this.componentObject.condition_operator_id === 1 ? 1 : 0
        // eslint-disable-next-line no-nested-ternary
        this.componentObject.condition_value = this.componentObject.condition_operator_id > 2 ? this.componentObject.subStatementValue > 0 ? this.componentObject.subStatementValue : 0 : Number(conditionValue)
      },
    },
    sub_statements: {
      handler() {
        if (this.sub_statements.length > 0) {
          this.componentObject.sub_statements = []
          this.sub_statements.map(e => this.SubStatementOptions.filter(el => {
            if (e === el.value) {
              this.componentObject.sub_statements.push({
                statement_id: el.value,
                statement_type: el.type,
              })
            }
            return this.componentObject.sub_statements
          }))
        }
      },
    },
    'componentObject.condition_id': {
      handler() {
        if (this.componentObject.condition_id === this.statementConditionID) {
          this.getSubStatements()
        }
        // DEB-461 show statementOperatorOptions for date type custom vars
        const filteredOptions = this.conditions.filter(e => e.value === this.componentObject.condition_id && e.type === 'date')
        if (filteredOptions.length) {
          this.operatorOptions.push(...this.statementOperatorOptions)
        } else {
          this.operatorOptions.splice(2)
        }
      },
    },
    dateOption: {
      handler() {
        this.componentObject.dateOption = this.varType === 'date' ? this.dateOption : null
      },
    },
  },
  created() {
    this.getCustomVars()
    this.getFileCategories()
    this.getCaseGroups()
    if (!this.componentObject.true_value) {
      this.componentObject.true_value = {
        variable: null,
        stringtype: true,
      }
    }
    if (!this.componentObject.false_value) {
      this.componentObject.false_value = {
        variable: null,
        stringtype: true,
      }
    }
    // this.componentObject.dacustom_variable_value = null
  },
  methods: {
    returnComponentObject() {
      this.$delete(this.componentObject, 'letterTemplates')
      return this.componentObject
    },
    getOptions(obj) {
      let arr = []
      if (obj.dacustom_variable_value) {
        // this.operatorOptions.push(...this.statementOperatorOptions)
        arr = [...this.operatorOptions, ...this.statementOperatorOptions]
      } else {
        arr = [...this.operatorOptions]
      }
      return arr
    },
    validateDate(type, value) {
      if (type === 0) {
        this.componentObject.custom_variable_value = this.$FormformattedDate(value)
      } else {
        this.componentObject.dacustom_variable_value = this.$DAformattedDate(value)
      }
    },
    defaultYesnoValueChanged(value, arr, functionalValue, type) {
      if (value === 'debtia.currencyConverter') {
        if (functionalValue) {
          this.fieldObject = {
            stringtype: false,
            currency_id: null,
            functional_value: functionalValue,
            statement_id: null,
            statement_type: '',
            variable: value,
          }
        } else {
          this.fieldObject = {
            stringtype: false,
            currency_id: arr[1],
            functional_value: null,
            statement_id: arr[0],
            statement_type: '',
            variable: value,
          }
        }
      } else if (value === 'dato_felt') {
        this.fieldObject = {
          stringtype: false,
          functional_value: functionalValue,
          variable: value,
        }
      } else if (value === 'module_run_date') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          variable: value,
        }
      } else if (value === 'interest_rate_percentage') {
        if (arr.length > 0) {
          this.fieldObject = {
            stringtype: false,
            functional_value: functionalValue,
            base_types: [],
            document_order: '',
            variable: value,
          }
        } else {
          this.fieldObject = {
            stringtype: false,
            functional_value: null,
            base_types: arr[0],
            document_order: arr[1],
            variable: value,
          }
        }
      } else if (value === 'letter_sent_date' || value === 'debtia.case_presentation') {
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          letters: [],
          order: '',
          variable: value,
        }
      } else if (value === 'debtia.freeText') {
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          free_text_note: null,
          variable: value,
        }
      } else {
        const customVar = this.templateVariableOptions.filter(e => e.value === value && e.custom_variable === true)
        this.fieldObject = customVar.length > 0 ? {
          variable: value,
          functional_value: null,
          custom_variable: true,
        } : {
          stringtype: true,
          variable: value,
        }
      }
      if (type) {
        this.componentObject.true_value = this.fieldObject
      } else {
        this.componentObject.false_value = this.fieldObject
      }
    },
    yesnoValueChanged(value, type) {
      if (value === 'debtia.currencyConverter') {
        this.fieldObject = {
          stringtype: false,
          currency_id: '',
          functional_value: null,
          statement_id: '',
          statement_type: '',
          variable: value,
        }
      } else if (value === 'dato_felt') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          variable: value,
        }
      } else if (value === 'module_run_date') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          variable: value,
        }
      } else if (value === 'interest_rate_percentage') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          base_types: [],
          document_order: '',
          variable: value,
        }
      } else if (value === 'letter_sent_date' || value === 'debtia.case_presentation') {
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          letters: [],
          order: '',
          variable: value,
        }
      } else if (value === 'debtia.freeText') {
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          free_text_note: null,
          variable: value,
        }
      } else if (value === 'debtia.paymentLink') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          module_type: this.moduleType,
          period_based_plan: false,
          amount_based_plan: false,
          max_months: null,
          min_amount: null,
          interest_free_months: null,
          payment_date: null,
          debtor_phone: null,
          template_id: this.emailTemplateId,
          employee_name: JSON.parse(localStorage.getItem('userData')).data.name,
          variable: value,
        }
      } else {
        const customVar = this.templateVariableOptions.filter(e => e.value === value && e.custom_variable === true)
        this.fieldObject = customVar.length > 0 ? {
          variable: value,
          functional_value: null,
          custom_variable: true,
        } : {
          stringtype: true,
          variable: value,
        }
      }
      if (type) {
        this.componentObject.true_value = this.fieldObject
      } else {
        this.componentObject.false_value = this.fieldObject
      }
    },
    vSelectChanged(value, id) {
      if (id.includes('sub_statements-') && value.length === 0) {
        this.componentObject.sub_statements = []
      }
      // eslint-disable-next-line valid-typeof
      if (((typeof value === 'string' || typeof value === 'number') && value) || (value.length > 0)) {
        const elementHTML = document.getElementById(id)
        const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
        ancestorWithClass.classList.remove('inputErrorClassField')
      }
    },
    valuechanged(value, id) {
      if (value) {
        this.$el.querySelector(`#${id}`).classList.remove('inputErrorClassField')
      }
    },
    radiochange(data) {
      const radioelement = document.getElementById(`radioerror-${data}`)
      radioelement.style.display = 'none'
    },
    refreshComponent() {
      this.removeErrorMsg()
      const elements = document.querySelectorAll('.inputErrorClassField')
      if (elements.length > 0) {
        for (let i = 0; i < elements.length; i += 1) {
          elements[i].classList.remove('inputErrorClassField')
        } // Force the component to re-render
      }
    },
    resetValues() {
      this.componentObject.functional_value = null
      this.componentObject.condition_value = 0
      this.componentObject.subStatementValue = null
      this.componentObject.condition_operator_id = null
      this.componentObject.true_value = {}
      this.componentObject.false_value = {}
      this.componentObject.custom_variable_id = 0
      this.componentObject.custom_option_id = 0
      this.componentObject.custom_variable_value = 'debtor'
      this.componentObject.file_category_id = 0
      this.componentObject.debt_case_group_id = 0
      this.componentObject.sub_statements = []
      this.componentObject.dateOption = null
      this.componentObject.letterTemplates = this.letterTemplates
      this.componentObject.statements = this.statements
    },
    async getSubStatements() {
      // this.busy = true
      const getStatementlabel = this.conditions.filter(e => e.value === this.componentObject.condition_id)
      this.SubStatementLabel = getStatementlabel.length > 0 ? getStatementlabel[0].label : ''
      this.sub_statements = []
      this.SubStatementOptions = []
      await axios.get('/get-sub-statements').then(response => {
        if (response.status === 200) {
          this.sub_statements = ''
          this.SubStatementOptions.push(...response.data.data)
          // this.busy = false
        }
      }).catch(error => console.log(error))
    },
    async getCustomVars() {
      this.loader = true
      await axios.get('/get-all-custom-vars').then(response => {
        if (response.status === 200) {
          this.customVarsArgs.push(...response.data.data)
          this.customVars = this.customVarsArgs.filter(e => e.var_for === this.componentObject.custom_variable_value)
        }
      }).catch(error => console.log(error))
      this.loader = false
    },
    getVarsFor() {
      this.customVars = this.customVarsArgs.filter(e => e.var_for === this.componentObject.custom_variable_value)
      this.componentObject.custom_variable_id = 0
    },
    isValidDateFormat(dateString) {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      return regex.test(dateString)
    },
    changeVariable(event, data) {
      // if (componentData) {
      //   if (this.isValidDateFormat(componentData)) {
      //     this.componentObject.custom_variable_value = this.$FormformattedDate(componentData)
      //     this.componentObject.dacustom_variable_value = this.$DAformattedDate(componentData)
      //   } else {
      //     this.componentObject.custom_variable_value = componentData
      //   }
      // }
      this.refreshComponent()
      setTimeout(() => {
        const elements = document.getElementsByClassName(`form-group-${data}`)
        this.mappable_validation_fields[data] = []
        for (let i = 0; i < elements.length; i += 1) {
          let dataID = elements[i].getAttribute('data-id')
          const fieldtype = elements[i].getAttribute('data-fieldtype')
          if (dataID === null) {
            dataID = 'custom_variable_value'
          }
          if (fieldtype === 'radio') {
            dataID = `${dataID}*radio`
          }
          this.mappable_validation_fields[data].push(dataID)
        }
      }, 50)
      this.varType = false
      this.CustomVarOption = ''
      this.CustomVariableOptions = []
      this.CustomVariableValue = ''
      this.conditions.filter(e => {
        if (event === e.value) {
          if (e.type === 'select') {
            if (e.options.length > 0) {
              this.CustomVariableOptions.push(...e.options)
            } else {
              this.CustomVariableOptions.push(...this.airportsData)
            }
          }
          // this.resetValues()
          this.varType = e.type
          this.componentObject.custom_variable_id = e.customVarID
        }
        return true
      })
    },
    async getFileCategories() {
      this.loader = true
      await axios.get('/settings/file-categories-dropdown').then(response => {
        if (response.status === 200) {
          this.fileCategories.push(...response.data.data)
        }
      }).catch(error => console.log(error))
      this.loader = false
    },
    async getCaseGroups() {
      this.loader = true
      await axios.get('/debt-case-groups-dropdown').then(response => {
        if (response.status === 200) {
          this.CaseGroups.push(...response.data.data)
        }
      }).catch(error => console.log(error))
      this.loader = false
    },
  },
}
</script>

<style>
.boolean-error {
  display: none;
  color: red !important;
}
</style>
